import { trackOnboardingSubmitted } from 'events/analytics';
import checkAuth from 'actions/user/checkAuth';
import configSelectors from 'selectors/configuration';
import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';
import userEvents from 'events/user';
import userSelectors from 'selectors/user';

const onboardIfNeeded = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let onboardingEnabled = configSelectors.getOnboarding(state.configuration).enabled;
    let email = userSelectors.getEmail(state.user);
    let name = userSelectors.getName(state.user);
    if (onboardingEnabled && email && name) {
      dispatch(trackOnboardingSubmitted({ email, name }));
      dispatch(userEvents.createOnboardingUser({ email, name }));
      dispatch(checkAuth);
      dispatch(uiEvents.updateCompositionStage(uiEnums.COMPOSITION_STAGES.MESSAGE));
    }
  };
};

export default onboardIfNeeded;
